import React from "react";
import Style from "./index.module.scss";

interface Props {
    src: string;
}
const VideoLocalPlayer = ({ src }: Props) => {
    return (
        <div className={Style.root}>
            <video className={Style.video} muted src={src} controls autoPlay />
        </div>
    );
};

export default VideoLocalPlayer;
